import { InternalPageLinkFragmentFragment } from '@fm-nx/contentful-types';

/**
 * Transform Contentful SDK link format to GraphQL InternalPageLinkFragmentFragment format
 */
export const transformLinkToGraphQL = (link: any): InternalPageLinkFragmentFragment | null => {
    if (!link || !link.fields) return null;

    const linkPage = link.fields.linkPage;
    if (!linkPage || !linkPage.fields || !linkPage.sys) return null;

    // Get the content type from the linkPage
    const contentTypeId = linkPage.sys.contentType?.sys?.id;
    if (!contentTypeId) return null;

    // Map content type to GraphQL __typename
    const typeNameMap: Record<string, string> = {
        pageCaseStudy: 'PageCaseStudy',
        pageIndustry: 'PageIndustry',
        pageLanding: 'PageLanding',
        pagePerson: 'PagePerson',
        pageService: 'PageService',
        pageCompany: 'PageCompany',
        pageJournal: 'PageJournal',
        pageTechnology: 'PageTechnology',
    };

    const typename = typeNameMap[contentTypeId];
    if (!typename) return null;

    return {
        __typename: 'InternalPageLink',
        linkText: link.fields.linkText || null,
        sys: {
            __typename: 'Sys',
            id: link.sys.id,
        },
        linkPage: {
            __typename: typename as any,
            slug: linkPage.fields.slug || null,
            sys: {
                __typename: 'Sys',
                id: linkPage.sys.id,
            },
        },
    };
};
